import React from 'react';
import columns from '../../../../react-table/helpers/columns';

export function getPropsForPercentage(index) {
  return ((state, rowInfo) => {
    let className = '';
    if (rowInfo) {
      if (rowInfo.original.monthYears[index] <= 100 && rowInfo.original.monthYears[index] >= 97 && rowInfo.original.pctPerformance !== null) {
        className = 'bg-through-dark-green';
      } else if (rowInfo.original.monthYears[index] <= 96.9 && rowInfo.original.monthYears[index] >= 95 && rowInfo.original.pctPerformance !== null) {
        className = 'bg-through-dark-yellow';
      } else if ((rowInfo.original.monthYears[index] <= 95 && rowInfo.original.monthYears[index] !== null && rowInfo.original.pctPerformance !== null) || rowInfo.original.monthYears[index] === 0.0) {
        className = 'bg-through-dark-red';
      }
    }
    return {
      className,
    };
  });
}

export function monthYearColumns(matrixRow, data) {
  const { PercentageColumn } = columns(data);
  return matrixRow.map((matrix, index) => ({
    Header: () => (
      <div />
    ),
    metadataForDownload: {
      firstLine: matrix.label,
    },
    columns: [
      new PercentageColumn(
        `${matrix.label}`,
        row => row.monthYears[index],
      ).withTotalHeaderEpg(`${data[0].monthYears[index]}%`, 'bg-total-grey-epg', `${data[1].monthYears[index]}%`, data[1], index).withId(`months${[index]}`).withGetProps(getPropsForPercentage(index)),
    ],
  }));
}
